import React, { useState, useEffect } from 'react';
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonLoading, IonToast, IonButton } from '@ionic/react';
import { 
  Box, 
  Card, 
  CardContent, 
  Typography, 
  Button, 
  CircularProgress,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Alert,
  IconButton,
  Tooltip,
  Stack,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TablePagination
} from '@mui/material';
import { Visibility, CheckCircle, Pending, Warning, Inventory } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { baseUrl, config, requestID } from '../../../common/utils';
import axios from 'axios';
import { useQuery } from 'react-query';
import { deleteRequestOrder } from '../../../api/stock-transfer/stock-transfer';
 
const StatusChip = styled(Chip)(({ theme }) => ({
  fontWeight: 500,
  '&.pending': {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.dark,
  },
  '&.completed': {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.success.dark,
  },
  '&.partial': {
    backgroundColor: theme.palette.info.light,
    color: theme.palette.info.dark,
  },
}));

const StyledCard = styled(Card)(({ theme }) => ({
  margin: theme.spacing(2),
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: theme.shadows[3],
}));

interface RequestItem {
  id: string;
  product_id: string;
  product_name: string;
  quantity: number;
  available: number;
  transferred?: number;
}

interface TransferRequest {
  id: string;
  requested_by: string;
  items: RequestItem[];
  status: 'pending' | 'completed' | 'partial';
  date: string;
  notes?: string;
}

const MyStewardStockTransferLogs: React.FC = () => {
  const [requests, setRequests] = useState<TransferRequest[]>([]);
  const [loading, setLoading] = useState(false);
    const [stewardStock, setStewardStock] = useState([]);
    const [stewardData, setStewardData] = useState([]);
    const [stockCount, setStockCount] = useState('');

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [transferDialogOpen, setTransferDialogOpen] = useState(false);
  const [currentRequest, setCurrentRequest] = useState<TransferRequest | null>(null);
  const [transferQuantities, setTransferQuantities] = useState<Record<string, number>>({});
  const [selectedStaff, setSelectedStaff] = useState("");

const [filteredStock, setFilteredStock] = useState([]);
const [searchTerm, setSearchTerm] = useState("");
const [page, setPage] = useState(0);
const [rowsPerPage, setRowsPerPage] = useState(10);
 const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedRequestId, setSelectedRequestId] = useState(null);

  useEffect(() => {
   // fetchPendingRequests();
  }, []);
 
  const getBarStaff = async () => {
    const payload = { requestID: requestID, config };
    const response = await axios.post(
      `${baseUrl()}settings/getBarStaff`,
      payload,
      config
    );
    console.log('stffs',{ response });

    return response.data.data;
  };


  const {
    data,
    isLoading,
    error: isError,
  } = useQuery("fetchStaffs", getBarStaff);

  
  const zeroStewardStock = async (selectedStaffx: string) => {
    console.log("Zeroing stock for:", selectedStaffx);
    const payload = {
      requestID: requestID,
      user_id: selectedStaffx || ""
    };
    try {
      const response = await axios.post(
        `${baseUrl()}warehouses/zeroStewardStock`,
        payload,
        config
      );
      console.log('Zero Stock Response:', response);
      setToastMessage(`Stock for ${selectedStaffx } has been zeroed.`);
      setShowToast(true);
      setFilteredStock([]); // Clear the filtered stock after zeroing
      setSelectedStaff(""); // Reset selected staff
    } catch (error) {
      console.error('Error zeroing stock:', error);
      setToastMessage("Failed to zero stock");
      setShowToast(true);
    }
  };  


  // const getStewardInventoryAlld = async () => {
  //   const payload = { requestID: requestID, 
  //     user_id: selectedStaff || ""
  //    };
  //   const response = await axios.post(
  //     `${baseUrl()}warehouses/getStewardInventoryAll`,
  //     payload,
  //     config
  //   );  
  //   console.log( response.data.data );

  //   setStewardData(response.data.data);
  // //  setStockCount(response.data.totalStockCount || '0');
  //   //return response.data.data;
  // };
const getStewardInventoryAll = async () => {
  const payload = {
    requestID, // no selectedStaff needed
  };

  const response = await axios.post(
    `${baseUrl()}warehouses/getStewardInventoryAll`,
    payload,
    config
  );

  return response.data; // expected to contain: { data: [...], totalStockCount: number }
};

 
const {
  data: stewardInventory,
  isLoading: isLoadingInventory,
  error: errorInventory,
  refetch, // <- this is the function you'll call
} = useQuery(["getStewardInventoryAll"], getStewardInventoryAll);


 

useEffect(() => {
  if (stewardInventory?.data) {
    const filtered = stewardInventory.data.filter(item => Number(item.qty) > 0);
    setStewardData(filtered);
    setStockCount(stewardInventory.totalStockCount || 0);
  }
}, [stewardInventory]);


  // const getStewardInventoryBy_user_id = async (selectedStaff) => {
  //   const payload = { requestID: requestID, 
  //     user_id: selectedStaff || ""
  //    };
  //   const response = await axios.post(
  //     `${baseUrl()}warehouses/getStewardInventoryBy_user_id`,
  //     payload,
  //     config
  //   );  
  //   console.log('stffs',{ response });

  //   setStewardStock(response.data.data);
  //   setStockCount(response.data.totalStockCount || '0');
  //   //return response.data.data;
  // };
  
useEffect(() => {
 
   getStewardInventoryAll();
  
}, []);


const handleViewStock = () => {
  const filtered = stewardData.filter(
    item => item.user_id === selectedStaff  || selectedStaff === ""
  );
 setFilteredStock(filtered);
 // setFilteredStock(stewardData);
  setToastMessage(`Viewing stock for ${selectedStaff || 'All Staff'}`);
  setShowToast(true);
  console.log('Filtered Stock:', filtered);
  console.log('Selected Staff:', selectedStaff);
};


 
 
 
    const handleCancel = async (selectedStaffx: string) => {
    //setLoading(true);
    console.log("Cancelling request:", selectedStaffx);
    setFilteredStock([]);

    zeroStewardStock(selectedStaffx);
    setToastMessage("Zero Stock successfully");
    setShowToast(true);
      setConfirmOpen(false); // Close the confirmation dialog

  };
      const [logs, setLogs] = useState([]);
  //const [loading, setLoading] = useState(true);

 



  const fetchLogs = async () => {
  const payload = {
    requestID, // no selectedStaff needed
  };
  setLoading(true);
  try {
  const res = await axios.post(
    `${baseUrl()}warehouses/getMyTransferLogs`,
    payload,
    config
  );
  console.log('Transfer Logs:', res.data);
 if (res.data.status === 'success') {
        setLogs(res.data.data);
      } else {
        console.error(res.data.message);
      }
    } catch (err) {
      console.error('Fetch failed:', err);
    } finally {
      setLoading(false);
    }
  //return response.data; // expected to contain: { data: [...], totalStockCount: number }
};



  useEffect(() => {
    fetchLogs();
  }, []);
 
    const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const paginatedLogs = logs.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  if (loading) return <CircularProgress />;



  return(
   <IonPage className='pushDown'>
      <IonHeader>
        <IonToolbar>
          <IonTitle>My Bar-Steward Requisition Logs</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <Box p={2}>
          <Paper elevation={2} sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
             My Inventory Transfer Logs
            </Typography>

            {loading ? (
              <Box display="flex" justifyContent="center" mt={4}>
                <CircularProgress />
              </Box>
            ) : (
              <>
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell><strong>ID</strong></TableCell>
                        <TableCell><strong>Steward</strong></TableCell>
                        <TableCell><strong>Product ID</strong></TableCell>
                        <TableCell><strong>Quantity</strong></TableCell>
                        <TableCell><strong>Transferred At</strong></TableCell>
                        <TableCell><strong>Zeroed By</strong></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {paginatedLogs?.map((log: any) => (
                        <TableRow key={log.id}>
                          <TableCell>{log.id}</TableCell>
                          <TableCell>{log.user_name || log.user_id}</TableCell>
                          <TableCell>{log.product_name}</TableCell>
                          <TableCell>{log.qty}</TableCell>
                          <TableCell>{log.transferred_at}</TableCell>
                          <TableCell>{log.zeroed_by_name || log.zeroed_by}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                <TablePagination
                  component="div"
                  count={logs.length}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  rowsPerPageOptions={[20]}
                  onPageChange={handleChangePage}
                />
              </>
            )}
          </Paper>
        </Box>
      </IonContent>
    </IonPage>
  );
};

export default MyStewardStockTransferLogs;